import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import { useAppSelector } from 'hooks/reduxHooks'
import { isSpoofed as isSpoofedSelector } from 'selectors/isSpoofed'

// The "close the sale" sidebar is piloted with agents in the flag's Optimizely audience (matched on spoofingAgentId).
function useSalesSidebarEnabled(): boolean {
  const isSpoofed = useAppSelector(isSpoofedSelector)
  const isPilotAgent = useFeatureFlag(OptimizelyFeatureFlags.aiOpsSpoofUpsellWhitelist)
  return isSpoofed && isPilotAgent
}

export default useSalesSidebarEnabled
